module.exports = __webpack_public_path__ + "img/pinkChrysanthemum.bbd1999b.jpg";